var React = require('react');

function InfoCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"rotate(180 9 9)"},[React.createElement("g",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","key":0},[React.createElement("circle",{"cx":"8","cy":"8","r":"8","key":0}),React.createElement("path",{"d":"M7.53 5v3.2","key":1})]),React.createElement("ellipse",{"cx":"7.529","cy":"11","fill":"currentColor","rx":"1","ry":"1","key":1})]));
}

InfoCircle.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;
